// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"RetailerCardMaxi_wrapper__19BBI"};